function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "43.527",
  height: "41.397"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4949",
  "data-name": "Group 4949",
  transform: "translate(1.02 1.073)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M21.176-.618l21.763 15.812-8.312 25.585H7.724L-.588 15.194zM39.412 16.34L21.176 3.09 2.939 16.34 9.9 37.779h22.548z",
  transform: "translate(-.433 -.455)",
  fill: "#fff"
}))));